import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, MenuList, Slide } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      zIndex: "5",
      left: "95px",
    },
    height: "100vh",
    background: "#fafafa",
    justifyContent: "right",
    boxShadow: "0px 0px 5px darkgrey",
    display: "flex",
  },
  list: {
    padding: "10px",
  },
}));

export default function SubMenu(props) {
  const classes = useStyles();

  if (props.index !== 0) {
    return (
      <Slide direction="right" in={props.open} mountOnEnter unmountOnExit>
        <Paper elevation={1} square className={classes.root}>
          <MenuList className={classes.list}>{props.children}</MenuList>
        </Paper>
      </Slide>
    );
  }
  return null;
}
